import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import Container from 'react-bootstrap/Container';
import { useStateValue } from '../../state';
import { authenticationService } from '../../services/auth';
import './index.css';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import personIcon from '../../assets/images/personIcon.png';
import Card from 'react-bootstrap/Card';
import Alert from 'react-bootstrap/Alert';
import { getErrorMessage } from '../../utils/errorMessage';

const Login = () => {
    const [{ authentication }, dispatch] = useStateValue();
    const [show, setShow] = useState(false);
    const [message, setMessage] = useState('');
    const [password, setPassword] = useState('');
    const [user, setUser] = useState('');

    const showMessage = (text) => {
        setMessage(text);
        setShow(true);
        setTimeout(() => setShow(false), 7000);
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        if (!password || !user) {
            showMessage('Campos de login nao preenchidos!');
            return;
        }

        try {
            const response = await authenticationService.login(user, password);

            if (response.status === 201 && response.data && response.data.token) {
                dispatch({ type: 'login', value: response.data });
                showMessage('Seja bem vindo!');
            }
        } catch (error) {
            showMessage(getErrorMessage(error, 'Nao foi possivel autenticar.'));
        }
    };

    return !authentication ? (
        <Container fluid className="login">
            <div className="login-shell">
                <div className="login-alert">
                    <Alert show={show} variant="info" dismissible onClose={() => setShow(false)}>
                        {message}
                    </Alert>
                </div>

                <section className="login-copy">
                    <span className="login-eyebrow">Portal de Agendamentos</span>
                    <h1>Clinica Psyquie</h1>
                    <p>
                        Agenda, pacientes e evolucoes clinicas em um fluxo unico, com acesso controlado
                        para a profissional e sua equipe.
                    </p>
                </section>

                <Card className="login-card">
                    <Card.Header align="center">
                        <Card.Img variant="bottom" src={personIcon} style={{ width: '10rem' }} />
                    </Card.Header>
                    <Card.Body>
                        <h3 className="login-form-title">Acessar portal</h3>
                        <p className="login-form-subtitle">Entre com o email cadastrado e sua senha.</p>

                        <Form onSubmit={handleSubmit}>
                            <Form.Control
                                type="email"
                                placeholder="Email"
                                className="mb-3"
                                value={user}
                                onChange={e => setUser(e.target.value)}
                            />

                            <Form.Control
                                type="password"
                                placeholder="Senha"
                                className="mb-3"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                            />

                            <Button type="submit" style={{ width: '100%' }} className="mb-2">
                                Entrar
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </Container>
    ) : (
        <Redirect to='/' />
    );
};

export default Login;
